import TableCoinCell from '@/components/core/Table/CustomCells/TableCoinCell';
import { BonusCoinMapping } from '@/models/bonusCoinMapping';
import { WalletService } from '@starsoft/common/services';
import { TableGridColumn } from '@starsoft/common/src/components/TableGrid/props';
import { getMoneyOrAmount } from '@starsoft/common/utils';

export const bonusCoinsColumns: TableGridColumn<BonusCoinMapping>[] = [
  {
    field: 'coin',
    headerName: 'table_coin',
    renderCell: coin => <TableCoinCell symbolOnly coin={coin?.coin} />,
  },
  {
    field: 'minimum',
    headerName: 'tournaments:min_label',
    valueFormatter: row =>
      WalletService.maskCurrency({
        amount: getMoneyOrAmount(row?.minimum),
        coin: row?.coin,
      }),
  },
  {
    field: 'maximum',
    headerName: 'tournaments:max_label',
    valueFormatter: row =>
      WalletService.maskCurrency({
        amount: getMoneyOrAmount(row?.maximum),
        coin: row?.coin,
      }),
    alignEnd: false,
  },
];
